import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import TimerOffOutlinedIcon from "@mui/icons-material/TimerOffOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import LinkOffOutlinedIcon from "@mui/icons-material/LinkOffOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { format } from "date-fns";

const day = (iso) => (iso ? format(new Date(iso), "dd/MM/yyyy") : null);

// body(d) recebe o retorno de GET auth/denial/:ref (ou null) e devolve JSX.
// Textos com (*) não estão nos mockups: Apêndice — Textos sem mockup (P1-12).
export const DENIAL_VARIANTS = {
  not_invited: {
    icon: PersonOffOutlinedIcon, tone: "warning", title: "Acesso ainda não liberado",
    body: (d) => (
      <>Sua conta {d?.attemptedEmail ? <><b>{d.attemptedEmail}</b> </> : ""}ainda não tem acesso ao Antecipe. Peça um convite a um administrador.</>
    ),
    info: "Registramos esta tentativa de acesso. Se você recebeu um convite em outro e-mail, entre com a conta Google desse e-mail.",
    action: "switch",
  },
  invite_expired: {
    icon: TimerOffOutlinedIcon, tone: "error", title: "Seu convite expirou",
    body: (d) =>
      d?.invitedEmail && d?.inviteExpiresAt ? (
        <>O convite enviado para <b>{d.invitedEmail}</b> venceu em <b>{day(d.inviteExpiresAt)}</b>. Convites valem 7 dias.</>
      ) : (
        <>Seu convite venceu. Convites valem 7 dias.</> // (*) fallback sem dados
      ),
    hint: "Peça ao administrador que reenvie o convite — você recebe um novo link por e-mail.",
    action: "switch",
  },
  wrong_account: {
    icon: AlternateEmailOutlinedIcon, tone: "warning", title: "Conta diferente do convite",
    body: (d) =>
      d?.invitedEmail && d?.attemptedEmail ? (
        <>O convite foi enviado para <b>{d.invitedEmail}</b>, mas você entrou com <b>{d.attemptedEmail}</b>.</>
      ) : (
        <>Você entrou com uma conta Google diferente da liberada para este acesso.</> // (*) account_mismatch sem convite
      ),
    hint: "O convite só vale para o e-mail convidado. Saia e entre com a conta certa.",
    action: "switch", // (*) mockup: "Entrar com <e-mail convidado>" — o FE só tem o e-mail mascarado
  },
  invite_superseded: { // (*) variante sem mockup (P1-8)
    icon: LinkOffOutlinedIcon, tone: "warning", title: "Este link de convite foi substituído",
    body: (d) => (d?.invitedEmail ? <>Um convite mais novo foi enviado para <b>{d.invitedEmail}</b>.</> : <>Um convite mais novo foi enviado para o seu e-mail.</>),
    hint: "Use o link do e-mail mais recente ou peça ao administrador que reenvie o convite.",
    action: null,
  },
  user_disabled: { // (*) disabled e invite_revoked
    icon: BlockOutlinedIcon, tone: "neutral", title: "Acesso desativado",
    body: (d) => (d?.attemptedEmail ? <>O acesso de <b>{d.attemptedEmail}</b> ao Antecipe foi desativado.</> : <>Seu acesso ao Antecipe foi desativado.</>),
    hint: "Se precisar voltar a acessar, fale com um administrador.",
    action: "switch",
  },
  generic: { // (*) no_permissions, email_unverified, oauth_*, state_mismatch, desconhecido, 404/sem ref
    icon: ErrorOutlineOutlinedIcon, tone: "error", title: "Não foi possível entrar no Antecipe",
    body: () => <>O login não foi concluído ou sua conta ainda não tem acesso liberado.</>,
    hint: "Tente de novo. Se persistir, fale com um administrador.",
    action: "retry",
  },
  forbidden: { // (*) PrivateRoute sem a permissão da tela (não vem do BE)
    icon: LockOutlinedIcon, tone: "neutral", title: "Sem permissão para esta tela",
    body: () => <>Seu acesso não inclui esta área do Antecipe.</>,
    hint: "Use o menu para ir às telas liberadas para você.",
    action: "home",
  },
};

// Agrupamento dos motivos granulares do BE (spec §2.11). Só a API define o motivo; nunca a URL.
const REASON_TO_VARIANT = {
  not_invited: "not_invited",
  invite_expired: "invite_expired",
  invite_email_mismatch: "wrong_account",
  account_mismatch: "wrong_account",
  invite_superseded: "invite_superseded",
  disabled: "user_disabled",
  invite_revoked: "user_disabled",
};

export const variantFor = (reason) =>
  Object.prototype.hasOwnProperty.call(REASON_TO_VARIANT, reason) ? REASON_TO_VARIANT[reason] : "generic";
